var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TrackCard',{attrs:{"trackProps":_vm.trackProps}},[_c('div',{staticClass:"wrapper-content"},_vm._l((_vm.tips),function(tip,index){return _c('div',{key:index,staticClass:"tip-item"},[_c('p',{domProps:{"innerHTML":_vm._s(tip)}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }